/**
 * Self-host Monaco Editor — load from local bundle instead of CDN.
 *
 * Without this, @monaco-editor/react fetches monaco-editor from jsdelivr CDN
 * at runtime. In cloud/GKE environments where the CDN may be unreachable,
 * this causes the editor to hang on "Loading..." permanently.
 *
 * Import this module once (side-effect) before any <Editor /> renders.
 */
import { loader } from "@monaco-editor/react";
import * as monaco from "monaco-editor";

// Configure Monaco workers using import.meta.url — Vite resolves these at build time.
// Each worker URL points to the ESM entry in the installed monaco-editor package.
self.MonacoEnvironment = {
  getWorker(_: unknown, label: string) {
    if (label === "json") {
      return new Worker(new URL("monaco-editor/esm/vs/language/json/json.worker.js", import.meta.url), { type: "module" });
    }
    if (label === "css" || label === "scss" || label === "less") {
      return new Worker(new URL("monaco-editor/esm/vs/language/css/css.worker.js", import.meta.url), { type: "module" });
    }
    if (label === "html" || label === "handlebars" || label === "razor") {
      return new Worker(new URL("monaco-editor/esm/vs/language/html/html.worker.js", import.meta.url), { type: "module" });
    }
    if (label === "typescript" || label === "javascript") {
      return new Worker(new URL("monaco-editor/esm/vs/language/typescript/ts.worker.js", import.meta.url), { type: "module" });
    }
    return new Worker(new URL("monaco-editor/esm/vs/editor/editor.worker.js", import.meta.url), { type: "module" });
  },
};

loader.config({ monaco });
